import { Modal } from "@mui/material";
import React, { useState } from "react";
import Styles from "./CompanyUserSelection.module.css";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const CompanyUserSelection = ({
  open,
  handleClose,
  type,
  handleSelection,
  handleSubmit,
  selected,
}) => {
  let company = useSelector(
    (state) => state?.gnaAdminSlice?.fetchCompany?.data,
  );
  const admins = useSelector(
    (state) => state?.gnaAdminSlice?.fetchAdmins?.data,
  );

  const [clicked, setClicked] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleClick = (id) => {
    setClicked((prevClicked) =>
      prevClicked.includes(id)
        ? prevClicked.filter((item) => item !== id)
        : [...prevClicked, id],
    );
  };

  const handleRemoveDeleteSelection = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    handleSelection(id);
  };

  const handleSubClick = () => {
    handleSubmit(clicked);
  };

  const sortedCompanies = (type === "Admin" ? admins : company)?.reduce(
    (acc, ele) => {
      if (selected?.includes(ele?.companyId || ele?.userId)) {
        acc.selected.push(ele);
      } else {
        acc.unselected.push(ele);
      }
      return acc;
    },
    { selected: [], unselected: [] },
  );

  const sortedList = [
    ...sortedCompanies.selected,
    ...sortedCompanies.unselected,
  ];

  const filteredList = sortedList.filter((ele) => {
    const searchValue = searchQuery.toLowerCase();
    const companyOrFullName = (
      ele?.companyName ||
      ele?.fullName ||
      ""
    ).toLowerCase();
    const idValue = (ele?.companyId || ele?.userId || "").toString();
    return (
      companyOrFullName.includes(searchValue) || idValue.includes(searchValue)
    );
  });

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.userSelectionContainer}`}>
        <div className={`display_flex_row modalHeading ${Styles.headingText}`}>
          <div className={`headingText ${Styles.finalHead}`}>
            Select {type}(s)
          </div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.selectionContainer}>
          <div className={Styles.searchWrapper}>
            <SearchIcon className={Styles.searchIcon} />

            <input
              type="text"
              placeholder="Search by company name..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={Styles.searchInput}
            />
          </div>
        </div>
        <div className={`scroll_bar_y ${Styles.selectionContainer}`}>
          {filteredList?.map((ele) => (
            <div
              className={`display_flex_row ${Styles.selectionContainerMain}`}
              onClick={() => handleClick(ele?.companyId || ele?.userId)}
              key={ele?.companyId || ele?.userId}
            >
              <div className="display_flex_row_gap_8">
                {selected?.includes(ele?.companyId || ele?.userId) ? (
                  <DeleteIcon
                    style={{ fontSize: "14px", color: "red" }}
                    onClick={(e) =>
                      handleRemoveDeleteSelection(
                        e,
                        ele?.companyId || ele?.userId,
                      )
                    }
                  />
                ) : clicked?.includes(ele?.companyId || ele?.userId) ? (
                  <CheckBoxIcon
                    style={{ fontSize: "14px", color: "var(--primary-color-text)" }}
                  />
                ) : (
                  <CheckBoxOutlineBlankIcon style={{ fontSize: "14px" }} />
                )}

                <div>
                  {ele?.companyName || ele?.fullName} {ele?.companyId}
                </div>
              </div>
              <div>{type === "Admin" && <>{ele?.userType}</>}</div>
            </div>
          ))}
        </div>
        {clicked?.length > 0 && (
          <div className={`display_flex_row_center ${Styles.submitButtonCon}`}>
            <div onClick={handleSubClick}>Submit</div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CompanyUserSelection;
